import { BreadCrumb } from '@/new/components/BreadCrumb/BreadCrumb';
import { Container } from '@/new/components/Container/Container';

export {
  BreadCrumb,
  Container,
};
